import React, { useEffect, useState } from 'react';
import { Modal, Button, Image } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faExclamationTriangle, 
  faKey, 
  faEnvelope, 
  faUserShield 
} from '@fortawesome/free-solid-svg-icons';

const ForceDataCompletionModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const { 
    usuario: { 
      cambioClave, 
      solicitarEmailPersonal, 
      completarEmergencia 
    }
  } = useSelector((state) => state.auth);
  
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const hasPendingActions = cambioClave || solicitarEmailPersonal || completarEmergencia;
    const isOnCompletionPage = location.pathname.startsWith('/cambio-clave');
    setShowModal(hasPendingActions && !isOnCompletionPage);
  }, [cambioClave, solicitarEmailPersonal, completarEmergencia, location.pathname]);

  const handleContinue = () => {
    navigate('/cambio-clave', { state: { from: location } });
  };

  if (!showModal) return null;

  return (
    <Modal 
      show={showModal} 
      backdrop="static" 
      keyboard={false} 
      centered
      className="border-warning"
    >
      <Modal.Header className="bg-warning text-dark">
        <div className="d-flex align-items-center w-100">
          <Image 
            src="https://api.sinterec.cl/public/images/SINTEREC_logo.jpg" 
            alt="Logo SINTEREC" 
            style={{ height: '40px' }}
            className="me-2"
          />
          <Modal.Title className="mb-0">
            <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
            ¡Atención! Datos requeridos
          </Modal.Title>
        </div>
      </Modal.Header>
      
      <Modal.Body className="py-4">
        <h5 className="mb-3">Para continuar usando la aplicación, debes completar:</h5>
        
        <ul className="list-unstyled mb-4">
          {cambioClave && (
            <li className="mb-2">
              <FontAwesomeIcon icon={faKey} className="text-warning me-2" />
              <strong>Cambiar tu contraseña temporal</strong>
            </li>
          )}
          {solicitarEmailPersonal && (
            <li className="mb-2">
              <FontAwesomeIcon icon={faEnvelope} className="text-warning me-2" />
              <strong>Agregar un email personal</strong>
            </li>
          )}
          {completarEmergencia && (
            <li className="mb-2">
              <FontAwesomeIcon icon={faUserShield} className="text-warning me-2" />
              <strong>Completar contacto de emergencia</strong>
            </li>
          )}
        </ul>
        
        <div className="alert alert-warning mb-0">
          Serás redirigido automáticamente a la página de completar datos.
        </div>
      </Modal.Body>
      
      <Modal.Footer className="border-top-0">
        <Button 
          variant="warning" 
          onClick={handleContinue}
          className="text-white fw-bold py-2 px-4"
        >
          Completar datos ahora
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ForceDataCompletionModal;